import template from './navbarTop.html';
import {NavbarTopController} from './navbarTop.controller.js';

const NavbarTopComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: NavbarTopController,
    controllerAs: 'vm',
    bindings: {
        searchCaption: '<',
        onFilter: '&'
    }
};

export {NavbarTopComponent};



// WEBPACK FOOTER //
// ./app/components/common/navbarTop/navbarTop.component.js